<div class="body">
    <mat-card class="card-cabeça-portal">
        <mat-card-content>
            <div *ngIf="!error;else errorTemplate">
                <div class="loading-shade" *ngIf="isLoadingResults">
                    <mat-spinner></mat-spinner>
                </div>

                <input hidden type="text" id="idMatriculaUnidadeCarregada">

                <div *ngIf="isAluno">
                    <app-aluno-portal></app-aluno-portal>
                </div>


                <!-- <div class="nome-unidade-curso">
                        <mat-card-title class="aluno_curso">
                            {{ cursoLocalStorage }}
                        </mat-card-title>
                        <mat-card-subtitle class="aluno_unidade">
                            {{ unidadeLocalStorage }}
                        </mat-card-subtitle>
                    </div> -->

                <!-- <div class="grade-icones">
                        <mat-grid-list class="qwert" cols="3" rowHeight="50%">
                            <mat-grid-tile>
                                <button mat-button class="botao-icone" (click)="gotoMinhasAulas(matriculaId)">
                                    <img class="icone_grade" src="../../../assets/minhas_aulas2.png" alt="logo_minhas_aulas">
                                    <p class="p-icone">Minhas Aulas</p>
                                </button>
                            </mat-grid-tile>
                            <mat-grid-tile>
                                <button mat-button class="botao-icone" (click)="goToFinaceiro(matriculaId)">
                                    <img class="icone_grade" src="../../../assets/financeiro2.png" alt="logo_financeiro">
                                    <p class="p-icone">Financeiro</p>
                                </button>
                            </mat-grid-tile>
                            <mat-grid-tile>
                                <button mat-button class="botao-icone" (click)="goToSolicitacoes(matriculaId)">
                                    <img class="icone_grade" src="../../../assets/solicitaçoes2.png" alt="logo_solicitaçoes">
                                    <p class="p-icone">Solicitações</p>
                                </button>
                            </mat-grid-tile>
                            <mat-grid-tile class="grid4"> <!-- lembrar de tirar a classe quando o botao Simulados estiver pronto
                                <button mat-button class="botao-icone" (click)="goToDocumentos(matriculaId)">
                                    <img class="icone_grade" src="../../../assets/documentos2.png" alt="logo_documentos">
                                    <p class="p-icone">Documentos</p>
                                </button>
                            </mat-grid-tile>
                            <mat-grid-tile>
                                <!-- <button mat-button class="botao-icone">
                                    <img class="icone_grade" src="../../../assets/simulados2.png" alt="logo_simulados">
                                    <p class="p-icone">Simulados</p>
                                </button>
                            </mat-grid-tile>
                            <mat-grid-tile class="grid6"> <!-- lembrar de tirar a classe quando o botao Simulados estiver pronto
                                <button mat-button class="botao-icone" (click)="goToEja(matriculaId)">
                                    <img class="icone_grade" src="../../../assets/eja_encceja2.png" alt="logo_eja_encceja">
                                    <p class="p-icone">Eja Encceja</p>
                                </button>
                            </mat-grid-tile>
                        </mat-grid-list>
                    </div> -->

                <div *ngIf="!isAluno">
                    <div class="grid grid--auto-fit">
                        <ng-container *ngFor="let item of info">
                            <div class="info" *ngIf='item.value !== "CANCELADO"'>
                                <mat-label>{{ item.label }}:</mat-label>
                                <mat-chip-list>
                                    <mat-chip color="primary" class="capitalize" selected
                                        (click)="abrirModalConsultarAlunos()">{{ item.value }}</mat-chip>
                                </mat-chip-list>
                            </div>
                            <div class="info" *ngIf='item.value === "CANCELADO"'>
                                <mat-label>{{ item.label }}:</mat-label>
                                <mat-chip-list>
                                    <mat-chip color="warn" class="capitalize" selected
                                        (click)="abrirModalConsultarAlunos()">{{ item.value }}</mat-chip>
                                </mat-chip-list>
                            </div>
                        </ng-container>
                    </div>

                    <mat-tab-group class="mt-1" *ngIf="!isLoadingResults" [selectedIndex]="selectedIndex">
                        <mat-tab label="Curso e Turma" style="color: white !important">
                            <ng-template matTabContent>
                                <app-aluno-curso-turma (onContinue)="changeTab(1)"
                                    (onUpdateMatricula)="getMatricula(true, true)"></app-aluno-curso-turma>
                            </ng-template>
                        </mat-tab>
                        <mat-tab [disabled]="!hasCurso">
                            <ng-template mat-tab-label>
                                <!-- <mat-icon class="example-tab-icon">monetization_on</mat-icon> -->
                                <span
                                    [matBadge]="(existePendenciaFinanceira ? '$' : '') + (existePendenciaContrato ? ' ! ' : '' )"
                                    matBadgeColor="warn"
                                    [matBadgeHidden]="!existePendenciaFinanceira && !existePendenciaContrato">
                                    Financeiro e Contrato &nbsp; </span>
                            </ng-template>
                            <ng-template matTabContent>
                                <app-aluno-financeiro-contrato
                                    (onUpdateMatricula)="getMatricula(true, true)"></app-aluno-financeiro-contrato>
                            </ng-template>
                        </mat-tab>
                        <mat-tab [disabled]="!hasCurso">
                            <ng-template mat-tab-label>
                                <!-- <mat-icon class="example-tab-icon">thumb_up</mat-icon> -->
                                <!-- <i class="fas fa-rocket"></i> -->
                                <span [matBadge]="quantidadeDocumentosPendentes" matBadgeColor="warn"
                                    [matBadgeHidden]="!quantidadeDocumentosPendentes">Documentos &nbsp;</span>
                            </ng-template>
                            <ng-template matTabContent>
                                <app-aluno-documentos (updateMatricula)="getMatricula(true)"></app-aluno-documentos>
                            </ng-template>
                        </mat-tab>
                        <mat-tab label="Provas e Certificados" *ngIf="!isAluno" [disabled]="!numeroMatricula">
                            <ng-template matTabContent>
                                <!-- <mat-icon class="example-tab-icon">thumb_up</mat-icon> -->
                                <app-aluno-provas-certificados></app-aluno-provas-certificados>
                            </ng-template>
                        </mat-tab>
                        <mat-tab [disabled]="!numeroMatricula">
                            <ng-template mat-tab-label>
                                <!-- <mat-icon class="example-tab-icon">thumb_up</mat-icon> -->
                                <!-- <i class="fas fa-rocket"></i> -->
                                <span [matBadge]="existePendenciaSolicitacaoAnexo ? '!' : ''"
                                    matBadgeColor="warn">Solicitações &nbsp;</span>
                            </ng-template>
                            <ng-template matTabContent>
                                <app-aluno-solicitacoes
                                    (onUpdateMatricula)="getMatricula(true, true)"></app-aluno-solicitacoes>
                            </ng-template>
                        </mat-tab>
                        <mat-tab label="Tickets" *ngIf="!isAluno" [disabled]="!numeroMatricula">
                            <ng-template matTabContent>
                                <app-aluno-tickets></app-aluno-tickets>
                            </ng-template>
                        </mat-tab>
                        <mat-tab label="Comunicação" *ngIf="!isAluno" [disabled]="!numeroMatricula">
                            <ng-template matTabContent>
                                <!-- <mat-icon class="example-tab-icon">task_alt</mat-icon> -->
                                <app-aluno-comunicacao></app-aluno-comunicacao>
                            </ng-template>
                        </mat-tab>
                        <mat-tab label="Portal do Aluno" *ngIf="!isAluno" [disabled]="!numeroMatricula">
                            <ng-template matTabContent>
                                <!-- <mat-icon class="example-tab-icon">thumb_up</mat-icon> -->
                                <app-aluno-portal-parametrizacao></app-aluno-portal-parametrizacao>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>

<ng-template #errorTemplate>
    <app-server-error></app-server-error>
</ng-template>

<ng-template #loading>
    <mat-spinner [diameter]="25"></mat-spinner>
</ng-template>